var React = require('react');

function Grid (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"currentColor","d":"M.5.5h9v9h-9zM11.5.5h9v9h-9zM11.5 11.5h9v9h-9zM.5 11.5h9v9h-9z"}));
}

Grid.defaultProps = {"fill":"none","viewBox":"0 0 21 21"};

module.exports = Grid;

Grid.default = Grid;
